var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgStarEmptyGray = function SvgStarEmptyGray(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 28 26",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#545353",
    d: "m27.333 10.32-9.586-.827L14 .667l-3.747 8.84-9.586.813 7.28 6.307L5.76 26 14 21.027 22.24 26l-2.173-9.373zM14 18.533 8.987 21.56l1.333-5.707-4.427-3.84 5.84-.506L14 6.133l2.28 5.387 5.84.507-4.427 3.84 1.334 5.706z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStarEmptyGray);
export default ForwardRef;